/**
 * ordersFilterFields.js
 *
 * LGX-653: Orders custom filter field catalog -- the per-entity config the shared
 * AdvancedFilterModal/Toolbar (src/features/AdvancedFilter) render from. Field keys and
 * operators match OrderDynamicSpecification.java's leaf handling on the backend
 * (backend-yms-demo/.../order/service/OrderDynamicSpecification.java) field-for-field.
 */

const TEXT_OPS = ["CONTAINS", "EQ"];
const DATE_OPS = ["GTE", "LTE", "EQ"];
const NUMBER_OPS = ["GTE", "LTE", "EQ"];

export const ORDER_STATUS_OPTIONS = ["New", "ReadyToShip", "Planned", "Shipped", "Cancelled", "Completed"];
export const ORDER_PAYMENT_METHOD_OPTIONS = ["PREPAID", "POSTPAY", "COLLECT"];
export const ORDER_MODE_OPTIONS = ["FCL", "LCL", "FTL", "LTL", "TL", "AIR", "PARCEL"];

export const ORDER_RULE_FIELDS = [
  {
    key: "orderNumber", label: "Order Number", type: "text", group: "Order",
    ops: TEXT_OPS, backendField: "orderNumber", placeholder: "e.g. MIT053",
  },
  {
    key: "officeCode", label: "Office Code", type: "text", group: "Order",
    ops: TEXT_OPS, backendField: "officeCode", placeholder: "e.g. DIAMOND-MET",
  },
  {
    key: "status", label: "Status", type: "select", group: "Order",
    options: ORDER_STATUS_OPTIONS, ops: ["EQ", "NEQ", "IN"], backendField: "status",
  },
  {
    key: "shipmentNumber", label: "Shipment Number", type: "text", group: "Order",
    ops: TEXT_OPS, backendField: "shipmentNumber", placeholder: "e.g. DIAMOND-MET-A00169",
  },
  {
    key: "poNumber", label: "PO#", type: "text", group: "Order",
    ops: TEXT_OPS, backendField: "poNumber", placeholder: "e.g. MITZ053",
  },
  {
    key: "mode", label: "Mode", type: "select", group: "Order",
    options: ORDER_MODE_OPTIONS, ops: ["EQ", "NEQ", "IN"], backendField: "requestedMode",
  },
  {
    key: "paymentMethod", label: "Payment Method", type: "select", group: "Order",
    options: ORDER_PAYMENT_METHOD_OPTIONS, ops: ["EQ", "NEQ", "IN"], backendField: "paymentMethod",
  },

  { key: "origin", label: "Origin Name", type: "text", group: "Route", ops: TEXT_OPS, backendField: "origin" },
  { key: "destination", label: "Destination Name", type: "text", group: "Route", ops: TEXT_OPS, backendField: "destination" },
  { key: "shipper", label: "Shipper", type: "text", group: "Route", ops: TEXT_OPS, backendField: "shipperName" },
  { key: "receiver", label: "Receiver", type: "text", group: "Route", ops: TEXT_OPS, backendField: "receiverName" },

  { key: "pickupDate", label: "Pickup Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "pickupDate" },
  { key: "deliveryDate", label: "Delivery Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "deliveryDate" },
  { key: "createdDate", label: "Created Date", type: "date", group: "Dates", ops: DATE_OPS, backendField: "createdDate" },

  { key: "weight", label: "Weight", type: "number", group: "Cargo", ops: NUMBER_OPS, backendField: "totalWeight" },
  { key: "pallets", label: "Pallets", type: "number", group: "Cargo", ops: NUMBER_OPS, backendField: "totalPallets" },
  { key: "orderValue", label: "Order Value", type: "number", group: "Cargo", ops: NUMBER_OPS, backendField: "orderTotalAmount" },
];
